export default {"src":"/_next/static/media/drawing-grid-for-beginners.0fb2712b.svg","height":630,"width":1200,"blurWidth":0,"blurHeight":0};